import { ERRORS } from './constants';

class BiankaError extends Error {
    constructor(error, status, description) {
        super(error.message);

        this.status = status;
        this.description = description;
        this.stack = error.stack;
    }
}
export class BiankaClientError extends BiankaError {
    constructor(error, status) {
        super(error, status, ERRORS.REPORT_ACTIVITY_CLIENT_FAILED);
    }
}
export class BiankaServerError extends BiankaError {
    constructor(error, status) {
        super(error, status, ERRORS.REPORT_ACTIVITY_SERVER_FAILED);
    }
}
